import { Button } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/root';
import { setActiveTab, setWikiMode } from '../../../redux/slices/wikiSlice';
import { ROUTES } from '../../../constants/routes';
import history from '../../../history';

const WikiTabs = () => {
  const wikiMode = useSelector((s:RootState) => s.wikiSlice.wikiMode);
  const dispatch = useDispatch();
  const onClick = name => {
    dispatch(setWikiMode(name));
    dispatch(setActiveTab('None'));
    history.push(ROUTES.WIKI);
  };
  return (
    <Wrapper>
      <Button2>
        <Button color="primary" variant={wikiMode === 'JURI' ? "contained" : 'text'} onClick={e => onClick("JURI")}>
          Jurisdiction
        </Button>
      </Button2>
      <Button2>
        <Button color="primary" variant={wikiMode === 'GLOSSARY' ? "contained" : 'text'} onClick={e => onClick("GLOSSARY")}>
          Glossary
        </Button>
      </Button2>
      <Button2>
        <Button color="primary" variant={wikiMode === 'KEYS' ? "contained" : 'text'} onClick={e => onClick("KEYS")}>
          Keys
        </Button>
      </Button2>
    </Wrapper>
  );
};

export default WikiTabs;

const Wrapper = styled.div`
  display: flex;
  gap: 4px;
  background: var(--neutral-100);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 4px;
  margin: 0 0 16px;
  width: 100%;
  box-sizing: border-box;
`;

const Button1 = styled.div`
  flex: 1;
  button {
    width: 100%;
    height: 44px;
    border-radius: 8px;
    font-weight: 600;
    text-transform: none;
    font-size: 0.9375rem;
    letter-spacing: 0.01em;
  }
`;

const Button2 = styled.div`
  flex: 1;
  button {
    width: 100%;
    height: 44px;
    border-radius: 8px;
    font-weight: 600;
    text-transform: none;
    font-size: 0.9375rem;
    letter-spacing: 0.01em;
  }
`;

const Button3 = styled(Button2)`
  flex: 0 0 300px;
`;
